/**
 * A plan's limit, reached (launch redesign 4b, Olivia 14 Oct). The API answers 402 with
 * `PLAN_DOCUMENT_LIMIT` or `PLAN_IMPORT_LIMIT` when starting a document or an import would go
 * over the plan; whichever screen made the request, one dialog explains it.
 */
export const PLAN_LIMIT_EVENT = "lilia:plan-limit";

export type PlanLimitCode = "PLAN_DOCUMENT_LIMIT" | "PLAN_IMPORT_LIMIT";

export function isPlanLimitCode(code: unknown): code is PlanLimitCode {
  return code === "PLAN_DOCUMENT_LIMIT" || code === "PLAN_IMPORT_LIMIT";
}

export function announcePlanLimit(code: PlanLimitCode) {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(PLAN_LIMIT_EVENT, { detail: { code } }));
}

/** An API error that keeps the server's code and status, so a caller can tell a limit from a failure. */
export class ApiRequestError extends Error {
  constructor(message: string, readonly code?: string, readonly status?: number) {
    super(message);
    this.name = "ApiRequestError";
  }
}
